<mat-card class="mat_card">         
    <mat-card-title class="card-title fz-40">Aviso</mat-card-title>
    <br/>
    <div class="col center">
        <label class="rob-26">
            Usted no tiene permisos para
            acceder a este servicio.
        </label>
    </div>
  </mat-card>